import { t } from "@redotech/redo-i18n";
import CalendarDateIcon from "@redotech/redo-icons/calendar-date.svg";
import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import {
  FieldId,
  InputPartType,
} from "@redotech/redo-return-core-common/return-flow-answers";
import { InputValidation } from "@redotech/redo-return-core-common/return-flow-enums";
import { InputState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";
import { INPUT } from "./input";

/**
 * Date input marked with `WARRANTIES_ORDER_DATE` so registration submission
 * stores the answer as the purchase date of the synthetic order.
 */
export const ORDER_DATE_INPUT = (
  Details: React.ComponentType<StepTypeDetailsProps<InputState>>,
): StepType<InputState, ModelStep.Input> => ({
  ...INPUT(Details),
  get title() {
    return t("Order date");
  },
  Icon: CalendarDateIcon,
  empty: {
    prompt: "When did you purchase the item?",
    description: "Please enter in the date of purchase",
    type: InputPartType.DATE,
    fieldId: FieldId.WARRANTIES_ORDER_DATE,
    validation: InputValidation.REQUIRED,
    next: undefined,
    exampleImage: undefined,
  },
  defaultInitialStateFn() {
    return { ...this.empty, partUUID: crypto.randomUUID() };
  },
});
